import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const TooltipArrow = TooltipPrimitive.Arrow;
